import api from "../../api";
/* eslint-disable */
export default {
  namespaced: true,
  state: {
    Duductions: [],
  },
  getters: {
    getDuductions(state) {
      return state.Duductions;
    },
  },
  mutations: {
    SetDuductions(state, data) {
      
      state.Duductions = [];
      state.Duductions = data;
    },
  },
  actions: {
    fetchAllDuductions({ commit }) {
      return new Promise((resolve, rej) => {
      api()
        .post(
          `duductions/getDuductions`,
          {},
          {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          }
        )
        .then((res) => {
          resolve(res);
          commit("SetDuductions", res.data);
        })
        .catch((err) => console.log(err));})
    },


    addDuduction({ dispatch }, data) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `duductions/addDuduction`,
            data,
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },
    editeDuduction(
      { dispatch },
      data
    ) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `duductions/editeDuduction`,
            data,
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {

            resolve(res);

          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },

    deleteDuduction({ dispatch }, serial) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `duductions/deleteDuduction`,
            { serial: serial },
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {

            resolve(res);

          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },
    getDuductionsBydedictionTypeId({ commit }, dedictionTypeId) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `duductions/getDuductionsBydedictionTypeId`,
            { dedictionTypeId: dedictionTypeId },
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            
            commit("SetDuductions", res.data);

            resolve(res);

          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },
  },
};
